// Source de vérité unique des sports proposés dans l'app.
//
// Avant ce fichier, trois listes divergeaient : l'onboarding proposait
// « Course à pied » / « Cyclisme », tandis que le formulaire du jour et le
// profil ne connaissaient que « Course » / « Vélo ». Résultat : tout sport
// choisi à l'inscription retombait sur l'emoji générique 🏅, et le picker du
// profil affichait des doublons du même sport sous deux noms.
//
// Les libellés ci-dessous sont canoniques. ALIASES rattrape les libellés
// historiques déjà stockés dans `sports_list` (aucune migration de données :
// on résout à l'affichage).

export const SPORTS = [
  { label: 'Course à pied', emoji: '🏃' },
  { label: 'Marche',        emoji: '🚶' },
  { label: 'Randonnée',     emoji: '⛰️' },
  { label: 'Cyclisme',      emoji: '🚴' },
  { label: 'Natation',      emoji: '🏊' },
  { label: 'Triathlon',     emoji: '🏆' },
  { label: 'Musculation',   emoji: '🏋️' },
  { label: 'CrossFit',      emoji: '💪' },
  { label: 'Hyrox',         emoji: '⚡' },
  { label: 'Yoga',          emoji: '🧘' },
  { label: 'Pilates',       emoji: '🤸' },
  { label: 'Danse',         emoji: '💃' },
  { label: 'Pole dance',    emoji: '🪩' },
  { label: 'Escalade',      emoji: '🧗' },
  { label: 'Arts martiaux', emoji: '🥋' },
  { label: 'Boxe',          emoji: '🥊' },
  { label: 'Football',      emoji: '⚽' },
  { label: 'Basketball',    emoji: '🏀' },
  { label: 'Handball',      emoji: '🤾' },
  { label: 'Volleyball',    emoji: '🏐' },
  { label: 'Rugby',         emoji: '🏉' },
  { label: 'Tennis',        emoji: '🎾' },
  { label: 'Padel',         emoji: '🎾' },
  { label: 'Badminton',     emoji: '🏸' },
  { label: 'Golf',          emoji: '⛳' },
  { label: 'Athlétisme',    emoji: '🏅' },
  { label: 'Équitation',    emoji: '🏇' },
  { label: 'Ski',           emoji: '⛷️' },
  { label: 'Snowboard',     emoji: '🏂' },
  { label: 'Surf',          emoji: '🏄' },
];

export const SPORT_LABELS = SPORTS.map((s) => s.label);

// Libellés historiques → libellé canonique. Sert uniquement à retrouver le bon
// emoji pour les comptes créés avant l'unification.
const ALIASES = {
  'Course': 'Course à pied',
  'Vélo': 'Cyclisme',
  'Pole danse': 'Pole dance',
  'Poledance': 'Pole dance',
  'Muscu': 'Musculation',
  'Judo': 'Arts martiaux',
};

const EMOJI_BY_LABEL = Object.fromEntries(SPORTS.map((s) => [s.label, s.emoji]));

/** Emoji d'un sport, y compris libellés historiques et sports saisis librement. */
export const sportEmoji = (label) => {
  if (!label) return '🏅';
  const canonical = ALIASES[label] ?? label;
  return EMOJI_BY_LABEL[canonical] ?? '🏅';
};

/** True si le sport fait partie de la liste proposée (≠ sport saisi librement). */
export const isKnownSport = (label) =>
  Boolean(label) && Boolean(EMOJI_BY_LABEL[ALIASES[label] ?? label]);